import { Client } from 'urql'
import { Mutation_Root } from 'src/@types/graphql'
import { deleteFeatureGroupConfigById } from 'src/screens/administration/configuration-management/features-configuration/feature-groups/featureGroupsConfigQueries'

export const deleteFeatureGroupConfig = (urqlClient: Client) => async (featureGroupId: number) => {
  const { data, error } = await urqlClient
    .mutation<
      { delete_feature_group_config: Mutation_Root['delete_feature_group_config'] },
      { featureGroupId: number }
    >(deleteFeatureGroupConfigById, { featureGroupId })
    .toPromise()

  if (error || data?.delete_feature_group_config?.affected_rows !== 1) {
    throw new Error('Feature group config deletion error')
  }

  return true
}
